module.exports = __webpack_public_path__ + "static/7-night-star-7c0aa73d0eaa726a3fa407bde43aa218.png";